import { render, staticRenderFns } from "./companylevel-add-or-update.vue?vue&type=template&id=9f088dae&"
import script from "./companylevel-add-or-update.vue?vue&type=script&lang=js&"
export * from "./companylevel-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports